import * as React from 'react'
import { TaskTagsMainConnected } from './TaskTagsMainConnected'
import { Provider } from 'react-redux'
import { mockState, createMockStore } from 'mockState'

export const TaskTagsMainExamples = () => {
  return (
    <div className="TaskTagsMainExamples exampleContainer">
      <h1 className="exampleHeader">default</h1>

      <Provider store={createMockStore(mockState)}>
        <TaskTagsMainConnected />
      </Provider>
    </div>
  )
}
